import {
  iconsExpenseApproved,
  iconsExpenseSubmitted,
  iconsExpenseClaimNo,
  iconsExpenseClaimDate,
  iconsExpenseClaimStatus,
  iconsExpenseReviewed,
  iconsExpenseSettled,
} from '../../../../assets/index';

import { getClaimStatusColor } from '../EmployeeExpenseClaim/constants';
import { DateUtil } from '../../../../utils';

export const firstHeaderColumn = headerData => [
  {
    title: 'Claim Number',
    value: headerData?.claimNo || '--',
    icon: iconsExpenseClaimNo,
  },
  {
    title: 'Submitted On',
    value: headerData?.submittedOn
      ? DateUtil.isoToDdMmYyyyHhMmSsSlice(headerData?.submittedOn)
      : '--',
    icon: iconsExpenseSubmitted,
  },
  {
    title: 'Approved On',
    value: headerData?.approvedOn
      ? DateUtil.isoToDdMmYyyyHhMmSsSlice(headerData?.approvedOn)
      : '--',
    icon: iconsExpenseApproved,
  },
];

export const secondHeaderColumn = headerData => [
  {
    title: 'Claim Date',
    value: headerData?.claimDate
      ? DateUtil.isoToDdMmYyyySlice(headerData?.claimDate)
      : '--',
    icon: iconsExpenseClaimDate,
  },
  {
    title: 'Reviewed By',
    value: headerData?.reviewedBy || '--',
    icon: iconsExpenseReviewed,
  },

  {
    title: 'Settled On',
    value: headerData?.settledOn || '--',
    icon: iconsExpenseSettled,
  },
];

export const thirdHeaderColumn = headerData => [
  {
    title: 'Claim Status',
    icon: iconsExpenseClaimStatus,
    value: (
      <span
        className="claim-status-badge"
        style={{
          backgroundColor: getClaimStatusColor(headerData?.claimStatus || ''),
          border: '1px solid #FECDCA',
          color: '#B42318',
        }}
      >
        {headerData?.claimStatus || '--'}
      </span>
    ),
  },
  {
    title: 'Reviewed On',
    value: headerData?.reviewedOn
      ? DateUtil.isoToDdMmYyyyHhMmSsSlice(headerData?.reviewedOn)
      : '--',
    icon: iconsExpenseClaimStatus,
  },
  {
    title: 'TransNo',
    value: headerData?.transNo || '--',
    icon: iconsExpenseClaimStatus,
  },
];
